import { ReactNode } from 'react';
import { X } from 'lucide-react';

interface Props { title: string; count?: number; onClose: () => void; actions?: ReactNode; children: ReactNode; className?: string; }

/** Tarjeta de panel derecho (variante B, aprobada 2026-10-06): slate-50, radio 12 px, contorno casi invisible, sin sombra ni divisores. */
export default function PaneShell({ title, count, onClose, actions, children, className = '' }: Props) {
  return (
    <section aria-label={title} className={`bg-slate-50 rounded-xl ring-1 ring-slate-900/[0.07] flex flex-col min-h-0 ${className}`}>
      <div className="h-11 px-4 flex items-center justify-between flex-shrink-0">
        <span className="text-sm font-semibold text-gray-900">
          {title}{count !== undefined && <span className="ml-1 font-normal text-gray-400">{count}</span>}
        </span>
        <div className="flex items-center gap-0.5 text-slate-500">
          {actions}
          <button onClick={onClose} aria-label={`Cerrar ${title}`} title="Cerrar" className="p-1.5 rounded-lg hover:bg-slate-200/60 hover:text-slate-700">
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
      {children}
    </section>
  );
}
